import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, Route } from '@angular/router';
import { AuthService } from './auth.service';
import { LocalStoreManager } from './local-store-manager.service';

@Injectable()
export class AuthGuard  {
  constructor(
    private authService: AuthService,
    private router: Router,
    private localStorage: LocalStoreManager) {
  }
  rights: number;

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    let url: string = state.url;
    return this.checkLogin(url);
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.canActivate(route, state);
  }

  canLoad(route: Route): boolean {

    const url = `/${route.path}`;
    return this.checkLogin(url);
  }


  checkLogin(url: string): boolean {

    if (this.authService.isLoggedIn) {
      return true;
    }
    

    this.authService.redirectLogoutUser();
    return false;
  }

}
